export default require('./Channel').default
